import React from 'react';
import styled from 'styled-components';
import FooterUsefulLinksMobile from './FooterUsefulLinksMobile';
import FooterUsefulLinksDesktop from './FooterUsefulLinksDesktop';
import { forDesktop } from '@westwing/ui-kit/breakPoints';
import useFooterUsefulLinks from 'OneWestwingFooter/hooks/useFooterUsefulLinks';

const FooterUsefulLinksWrapper = styled.div`
    ${forDesktop`
        margin-bottom: 24px;
    `}
`;
const SeoLinks = styled.div`
    display: none;
`;

const FooterUsefulLinks = ({
    track,
    isClub,
    hasSeoLinks,
}: {
    track: (trackingAction: string) => void;
    isClub?: boolean;
    hasSeoLinks?: boolean;
}) => {
    const { usefulLinks: footerUsefulLinks, seoLinks } = useFooterUsefulLinks(isClub);

    return (
        <FooterUsefulLinksWrapper>
            <FooterUsefulLinksMobile
                isClub={isClub}
                hasSeoLinks={hasSeoLinks}
                track={track}
                footerLinks={footerUsefulLinks}
            />
            <FooterUsefulLinksDesktop track={track} footerLinks={footerUsefulLinks} />
            <SeoLinks>
                {seoLinks.map(
                    ({ to, text }) =>
                        to && (
                            /* Regular anchors are being used here for SEO bots that parse the DOM (in both Shop and Club).
                            Since these SEO links are not accessible to real users, there's no need to use hybrid links here */
                            // eslint-disable-next-line react/forbid-elements
                            <a href={to} key={to}>
                                {text}
                            </a>
                        )
                )}
            </SeoLinks>
        </FooterUsefulLinksWrapper>
    );
};

export default FooterUsefulLinks;
